import { useTranslation } from "react-i18next";

import { DeleteOutlineIcon } from "@dotnet/telematics-design-system";

import { ICON_DEFAULT_STYLE } from "../../../../../../../../shared";
import ListChoice from "../../../../../../../ListChoice/ListChoice";

interface RemoveCompanyCardButtonProps {
  onOptionClick: () => void;
}

const RemoveCompanyCardButton = ({
  onOptionClick
}: RemoveCompanyCardButtonProps) => {
  const { t } = useTranslation();

  return (
    <ListChoice
      data-testid="remove-company-card-option"
      title={t("Details##remove")}
      iconLeft={<DeleteOutlineIcon style={ICON_DEFAULT_STYLE} />}
      onClick={onOptionClick}
      alignIconCenter
    />
  );
};

export default RemoveCompanyCardButton;
